import Error from '../model/Error.js';
import News from '../dto/News.js'
import axios from 'axios';

export default class NewsRepository {
    static findAll(kindergartenId, params) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/news`, { params })
                .then(response => {
                    const data = response.data.data.map(data => News.fromData(data));
                    const meta = response.data.meta || {};
                    resolve({ data, meta });
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findById(newsId, params) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/news/${newsId}`, { params })
                .then(response => resolve(News.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static createTranslations(newsIds, translationLanguage) {
        return new Promise((resolve, reject) => {
            axios
                .post('/kindergartens/news/translations', { ids: newsIds, translationLanguage: translationLanguage })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static patchTopNews(newsId, topNews) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/news/${newsId}/top-news`, { topNews })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
